import formatTimeOfDay from '../../../utils/formatTimeOfDay.js'
import { useAtomValue } from 'jotai'
import PropTypes from 'prop-types'
import { timestampsAtom } from '../../../store/timestamps.store.js'
import { runnerAtom } from '../../../store/runner.store.js'
import { addMilliseconds } from 'date-fns'

/**
 * EndOfShow component
 *
 * Shows a single "Calculated end" time for the rundown.
 * - Before the show is running (preshow), this is the projected end based on
 * the planned durations (`original`).
 * - While the show is running, this is the live end based on actual timing
 * (`actual`).
 */
export default function EndOfShow({ timezone, todDisplayFormat }) {
  const timestamps = useAtomValue(timestampsAtom)
  const runner = useAtomValue(runnerAtom)

  if (!timestamps) return null

  // Preshow → the planned projection; running → the live actual timing.
  const source = runner ? timestamps.actual : timestamps.original
  const calculatedEnd = addMilliseconds(source.start, source.duration)

  return (
    <section>
      <div
        className={[
          'pl-1.5 text-gray-500 font-semibold whitespace-pre text-[10px]',
        ].join(' ')}
      >
        Calculated end
      </div>
      <div className="h-6 px-1.5 flex items-center font-mono tabular-nums">
        {formatTimeOfDay(calculatedEnd, {
          timezone,
          seconds: 'nonzero',
          format: todDisplayFormat,
        })}
      </div>
    </section>
  )
}

EndOfShow.propTypes = {
  timezone: PropTypes.string,
  todDisplayFormat: PropTypes.string,
}
